import React, { useState, useEffect, useRef, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import { motion } from "framer-motion";
import { imgAboutJpg } from "../../assets/images";
import { mediaQueries } from "../../constant";
import styles from "./styles.module.scss";

export default function About() {
  const refHeading = useRef();
  const refContent = useRef();
  const [elTopHeading, setElTopHeading] = useState(0);
  const [elTopContent, setElTopContent] = useState(0);
  const [showElHeading, setShowElHeading] = useState(false);
  const [showElContent, setShowElContent] = useState(false);
  const [startingPoint, setStartingPoint] = useState(0);

  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.miniDesktop}px)`,
  });

  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );
  const variantContent = useMemo(
    () => ({
      offScreen: {
        x: isBiggerScreen ? 50 : 0,
        y: isBiggerScreen ? 0 : 50,
        opacity: 0,
      },
      onScreen: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
        },
      },
    }),
    [isBiggerScreen]
  );
  const variantSubContent = useMemo(
    () => ({
      offScreen: {
        x: isBiggerScreen ? 50 : 0,
        y: isBiggerScreen ? 0 : 50,
        opacity: 0,
      },
      onScreen: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
          delay: 1,
        },
      },
    }),
    [isBiggerScreen]
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elTopHeading > 0 &&
      window.pageYOffset + startingPoint > elTopHeading
    ) {
      setShowElHeading(true);
    } else {
      setShowElHeading(false);
    }
    if (
      window.pageYOffset > 0 &&
      elTopContent > 0 &&
      window.pageYOffset + startingPoint > elTopContent
    ) {
      setShowElContent(true);
    } else {
      setShowElContent(false);
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.85);
      if (refHeading.current) setElTopHeading(refHeading.current.offsetTop);
      if (refContent.current) setElTopContent(refContent.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refHeading, refContent]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });

  useEffect(() => {
    console.log(isBiggerScreen);
  }, [isBiggerScreen]);

  return (
    <div
      className={clsx(
        "mt-12 md:py-12 lg:py-16 relative overflow-hidden",
        styles.about
      )}
    >
      <div className="absolute hidden lg:block top-0 left-0 w-1/2 h-full">
        <div className="relative h-full overflow-hidden">
          <img src={imgAboutJpg} alt="Tentang Kami" />
        </div>
      </div>
      <div
        className={clsx(
          "py-12 lg:p-24 flex items-center justify-end",
          styles.container
        )}
      >
        <motion.div
          variants={variantContainer}
          initial="offScreen"
          whileInView={showElHeading ? "onScreen" : "offScreen"}
          // viewport={{ once: true }}
          className="w-full lg:w-1/3"
        >
          <motion.h2
            ref={refHeading}
            variants={variantContent}
            className={clsx(
              "text-4xl md:text-5xl headline-remo text-center md:text-left"
            )}
          >
            Tentang <span>Oxone</span>
          </motion.h2>
          {!isBiggerScreen && (
            <motion.div
              variants={variantContent}
              className="relative overflow-hidden -mx-4 w-screen lg:hidden"
            >
              <img src={imgAboutJpg} alt="Tentang Kami" />
            </motion.div>
          )}
          <motion.p
            ref={refContent}
            variants={variantSubContent}
            initial="offScreen"
            whileInView={showElContent ? "onScreen" : "offScreen"}
            className="mt-8 text-base lg:text-xl text-justify"
          >
            Merupakan perusahaan yang bergerak di bidang pendistribusian produk
            kebutuhan rumah tangga. Kami menyediakan produk yang memenuhi fungsi
            Ergonomis dan Estetika baik di penggunaan maupun kualitas. Kami akan
            terus berkembang dan memberikan yang terbaik bagi konsumen sebagai
            salah satu wujud komitmen kami kepada para konsumen. Integrasi dan
            mutu menjadi salah satu cermin dari pelayanan kami.
          </motion.p>
        </motion.div>
      </div>
    </div>
  );
}
